import { useEffect, useState } from "react";

const SLOW_AFTER_MS = 8_000;

/** True once a request has been in flight long enough to tell the user we are still working. */
export const useTakingLonger = (active: boolean) => {
  const [takingLonger, setTakingLonger] = useState(false);

  useEffect(() => {
    if (!active) {
      setTakingLonger(false);
      return;
    }

    const timer = window.setTimeout(() => setTakingLonger(true), SLOW_AFTER_MS);
    return () => window.clearTimeout(timer);
  }, [active]);

  return takingLonger;
};
